import { PeerTypes } from '@givebacks/api/store';
import { PeerDonationCredit } from 'core/Components';
import { Modal, ModalProps, ScrollArea } from 'ui';

interface CreditPeerModal extends ModalProps {
  onStart: (cartCredit: CartPeerCredit) => void;
  storeItemId?: string;
  storeId?: string;
}

type CartPeerCredit = {
  status?: 'pledge_required' | undefined;
  credit_to: string[] | undefined;
  credit_write_in: string[] | undefined;
  peerType?: PeerTypes | null;
};

const PeerCreditModal = ({
  opened,
  onClose,
  title,
  onStart,
  storeItemId,
  storeId,
}: CreditPeerModal) => {
  if (!storeItemId || !storeId) return null;

  return (
    <Modal
      title={title ?? 'Donate'}
      opened={opened}
      onClose={() => {
        onClose();
      }}
      scrollAreaComponent={ScrollArea.Autosize}
    >
      <PeerDonationCredit
        onProceed={onStart}
        storeId={storeId}
        storeItemId={storeItemId}
        withCheckoutButtons={true}
      />
    </Modal>
  );
};

export { PeerCreditModal };
